import React from 'react';
import { useEyeMove } from "../hooks/useEyeMove.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Illustration404() {
  const leftEye = {
    x: 158,
    y: 57
  };
  const rightEye = {
    x: 167,
    y: 57
  };
  const {
    svg,
    translatedLeftEye,
    translatedRightEye
  } = useEyeMove({
    leftEye,
    rightEye
  });
  return /*#__PURE__*/_jsx("svg", {
    ref: svg,
    width: "343",
    height: "130",
    viewBox: "0 0 343 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M0.619049 79.7148L56.2281 0.619049H83.1369V83.3944H98.384V104.547H83.1369V129.381H60.7125V104.547H0.619049V79.7148ZM60.7125 83.3931V30.0498L23.041 83.3944L60.7125 83.3931Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.2381"
      }), /*#__PURE__*/_jsx("path", {
        d: "M119.117 65C119.117 31.3238 144.231 10.379 172.033 10.379C199.836 10.379 224.953 31.33 224.953 65C224.953 98.67 199.839 119.62 172.033 119.62C144.228 119.62 119.117 98.6688 119.117 65Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.2381",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M244.568 79.7148L300.175 0.619049H327.081V83.3944H342.328V104.547H327.086V129.381H304.664V104.547H244.568V79.7148ZM304.664 83.3931V30.0498L266.994 83.3944L304.664 83.3931Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.2381"
      }), /*#__PURE__*/_jsx("path", {
        d: "M158.773 57.7819C160.108 57.7819 161.19 56.6999 161.19 55.3651C161.19 54.0304 160.108 52.9484 158.773 52.9484C157.439 52.9484 156.357 54.0304 156.357 55.3651C156.357 56.6999 157.439 57.7819 158.773 57.7819Z",
        fill: "#272727",
        transform: `translate(${translatedLeftEye?.x} ${translatedLeftEye?.y})`
      }), /*#__PURE__*/_jsx("path", {
        d: "M185.763 57.7522C187.097 57.7522 188.179 56.6702 188.179 55.3354C188.179 54.0007 187.097 52.9187 185.763 52.9187C184.428 52.9187 183.346 54.0007 183.346 55.3354C183.346 56.6702 184.428 57.7522 185.763 57.7522Z",
        fill: "#272727",
        transform: `translate(${translatedRightEye?.x} ${translatedRightEye?.y})`
      }), /*#__PURE__*/_jsx("path", {
        d: "M166.739 73.3299C167.194 72.2542 167.952 71.3342 168.921 70.6825C169.89 70.0308 171.028 69.6756 172.196 69.6603C173.363 69.6451 174.51 69.9705 175.496 70.5967C176.482 71.2229 177.264 72.1228 177.746 73.1863",
        stroke: "#272727",
        strokeWidth: "1.2381",
        strokeLinecap: "round"
      })]
    })
  });
}